import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedFilters } from "../../bloc/payoutsSlice";
import { TRootState } from "../../../../../store";
import { toast } from "react-toastify";


const usePayoutFilter = () => {

    const types = ['All', 'Loan', 'Trade', 'Third Party' ];
    const statuses = ['All', 'Processed', 'Rejected', 'Initiated', 'Returned'];

    const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
    const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
    const [selectedCustomers, setSelectedCustomers] = useState<string[]>([]);

    const dispatch = useDispatch();

    const {
        filters,
        customers,
    } = useSelector((state: TRootState) => ({
        filters: state.payouts.filters,
        customers: state.payouts.customers,
    }));

    const customerOptions = customers?.map((customer) => ({
        id: customer.benCode,
        label: customer.customerName,
        value: customer.benCode,
        mobile: "",
        type: "FUND ACC ID",
        profilePic: "",
        address: "",
    }));

    useEffect(() => {
        setSelectedTypes(filters.selectedTypes);
        setSelectedStatuses(filters.selectedStatuses);
        setSelectedCustomers(filters.selectedCustomers);
    }, []);

    const onSelectType = (type: string) => {
        if (type == 'All') {
            let updatedTypes = selectedTypes.includes(type)
                ? []
                : [...types];
            setSelectedTypes(updatedTypes);
        } else {
            let updatedTypes = selectedTypes.includes(type)
                ? selectedTypes.filter((t) => t !== type && t !== 'All')
                : [...selectedTypes, type];
            if (updatedTypes.length == types.length - 1) {
                updatedTypes = [...updatedTypes, 'All'];
            }
            setSelectedTypes(updatedTypes);
        }
    }

    const onResetType = () => {
        setSelectedTypes([]);
    }

    const onSelectStatus = (status: string) => {
        if (status == 'All') {
            let updatedStatuses = selectedStatuses.includes(status)
                ? []
                : [...statuses];
            setSelectedStatuses(updatedStatuses);
        } else {
            let updatedStatuses = selectedStatuses.includes(status)
                ? selectedStatuses.filter((t) => t !== status && t != 'All')
                : [...selectedStatuses, status];
            if (updatedStatuses.length == statuses.length - 1) {
                updatedStatuses = [...updatedStatuses, 'All'];
            }
            setSelectedStatuses(updatedStatuses);
        }
    }

    const onResetStatus = () => {
        setSelectedStatuses([]);
    }

    const onSeletCustomer = (customers: any) => {
        setSelectedCustomers(customers.map((c: any) => c.value));
    }

    const onResetCustomers = () => {
        setSelectedCustomers([]);
    }

    const onApply = () => {
        dispatch(
            setSelectedFilters({
                selectedTypes: selectedTypes,
                selectedStatuses: selectedStatuses,
                selectedCustomers: selectedCustomers,
            }),
        );
    }

    const onReset = () => {
        setSelectedTypes([]);
        setSelectedStatuses([]);
        setSelectedCustomers([]);
        dispatch(
            setSelectedFilters({
                selectedTypes: [],
                selectedStatuses: [],
                selectedCustomers: [],
            }),
        );
        toast.success('Filters reset successfully');
    }

    const isFilterApplied = () => {
        return filters.selectedTypes.length > 0 || filters.selectedStatuses.length > 0 || filters.selectedCustomers.length > 0;
    }

    return {
        types,
        statuses,
        selectedTypes,
        selectedStatuses,
        onSelectType,
        onResetType,
        onSelectStatus,
        onResetStatus,
        onApply,
        onReset,
        isFilterApplied,
        onSeletCustomer,
        customers,
        selectedCustomers,
        customerOptions,
        onResetCustomers,
    };
}

export default usePayoutFilter;